import { render, staticRenderFns } from "./SizeSetting.vue?vue&type=template&id=29b6c6f3&"
import script from "./SizeSetting.vue?vue&type=script&lang=js&"
export * from "./SizeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports